import { useEffect, useState } from "react";

/**
 * Hook to determine if the podcast player is displaying a Catfish ad.
 */
const usePodcastPlayerStyle = () => {
  const [isCatfishAd, setIsCatfishAd] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const container = document.querySelector(
        '[data-testid="dfp-ad-catfish"]'
      );
      const iframe = container?.querySelector("iframe");
      const height = Number(iframe?.style?.height?.replace("px", ""));
      const isVisible = height > 0;

      setIsCatfishAd(!!isVisible);
    }, 300);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return isCatfishAd;
};

export default usePodcastPlayerStyle;
